export default "__VITE_ASSET__BkcqlVAf__"